import { useModalStore } from "./modals.store";
import { Component } from "vue";
export function useDialogComposable({
  title,
  component,
  props,
  listeners,
  showHeader,
  allowClose,
}: {
  title?: string;
  component: Component;
  props: Record<string, any>;
  listeners?: Record<string, (...args: any[]) => void>;
  showHeader?: boolean;
  allowClose?: boolean;
}) {
  const modalStore = useModalStore();
  let closeFn: () => void = () => {};

  const controller = useNewDialogController();

  async function open(
    overrideListeners?: Record<string, (...args: any[]) => void>
  ) {
    const mergedListeners = { ...listeners, ...overrideListeners };
    const { close } = modalStore.openModal({
      title,
      component,
      props,
      listeners: mergedListeners,
      controller: controller.value,
      showHeader: showHeader ?? true,
      allowClose: allowClose ?? true,
    });
    closeFn = close;

    await nextTick();

    controller.value.open();
  }

  function close() {
    controller.value.close();
  }

  return {
    open,
    close,
  };
}
